export default __webpack_public_path__ + "static/media/arrow-down-green.f9055b54.svg";